import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import refresh_enabled from "../../../../../asset/image/refresh-enabled.svg"
import refresh_disabled from "../../../../../asset/image/refresh-disabled.svg"
import './gradientButton.css';

interface GradientButtonProps {
  label: string;
  disabled?: boolean;
  onClick?: () => void;
}

const GradientButton: React.FC<GradientButtonProps> = ({ label, disabled, onClick }) => {
  return (
    <button className={`common-gradient-button${disabled ? ' disabled' : ''}`} disabled={disabled} onClick={() => onClick?.()}>
      <span className="icon"><img src={disabled ? refresh_disabled : refresh_enabled} alt="" /></span>
      {label}
    </button>
  );
};

export default GradientButton;